import { Link } from "react-router-dom";

export function Landing() {
  return (
    <>
      <header className="topbar">
        <div className="container topbar-inner">
          <Link to="/" className="brand">
            <img src="/logo.svg" alt="" width={44} height={44} />
            <div className="brand-text">
              <span>Spitalul Marie Curie</span>
              <small>Platformă internă de formare</small>
            </div>
          </Link>
          <nav className="nav-links">
            <Link to="/" className="active">Acasă</Link>
            <a href="#program">Despre program</a>
            <a href="#cum-functioneaza">Cum funcționează</a>
            <a href="#contact">Contact intern</a>
          </nav>
          <div className="nav-actions">
            <Link to="/login" className="btn btn-primary btn-sm">
              <i className="fa-solid fa-right-to-bracket"></i> Intră în platformă
            </Link>
          </div>
        </div>
      </header>

      <section className="hero">
        <div className="container hero-grid">
          <div>
            <span className="eyebrow"><span className="dot"></span>Acces rezervat personalului spitalului</span>
            <h1>Formare profesională <span className="accent">continuă</span>, în spitalul nostru.</h1>
            <p className="lead">Platforma internă de educație medicală a Spitalului Marie Curie. Medicii, rezidenții și asistenții accesează cursurile alocate rolului lor, susțin examenele și își păstrează evidența creditelor EMC.</p>
            <div className="hero-cta">
              <Link to="/login" className="btn btn-primary btn-lg"><i className="fa-solid fa-right-to-bracket"></i> Autentificare</Link>
              <a href="#cum-functioneaza" className="btn btn-ghost btn-lg"><i className="fa-solid fa-circle-info"></i> Cum funcționează</a>
            </div>
            <div className="hero-stats">
              <div className="stat"><strong>3</strong><span>Categorii de personal</span></div>
              <div className="stat"><strong>EMC</strong><span>Credite eligibile</span></div>
              <div className="stat"><strong>24/7</strong><span>Acces din spital sau de acasă</span></div>
            </div>
          </div>
          <div className="hero-visual">
            <div className="hero-card">
              <div className="hero-card-title"><strong>Neonatologie — Modul 3</strong><span className="tag">În curs</span></div>
              <small className="muted">Resuscitarea nou-născutului</small>
              <div className="progress"><span style={{ width: "68%" }}></span></div>
              <small className="muted">8 / 12 lecții complete</small>
            </div>
            <div className="hero-card">
              <div className="hero-card-title"><strong>Examen — Cardiologie pediatrică</strong><span className="tag" style={{ background: "#fde6eb", color: "#a8092b" }}>Mâine</span></div>
              <small className="muted">25 întrebări · 45 minute</small>
            </div>
            <div className="hero-card">
              <div className="hero-card-title"><strong>Certificat obținut</strong><span className="tag" style={{ background: "#e6f6ee", color: "#0b6b46" }}>Promovat</span></div>
              <small className="muted">Îngrijirea prematurului · 14 mai 2026</small>
            </div>
          </div>
        </div>
      </section>

      <section id="program">
        <div className="container">
          <div className="section-head">
            <span className="eyebrow"><span className="dot"></span>Despre program</span>
            <h2>O platformă pentru întreaga echipă medicală</h2>
            <p>Fiecare categorie de personal are propriul catalog de cursuri.</p>
          </div>
          <div className="grid-3">
            <Feature icon="fa-user-doctor" bg="var(--c-primary-light)" color="var(--c-primary-dark)" title="Medici">
              Cursuri de specialitate, ghiduri terapeutice actualizate, evaluări clinice. Credite EMC eliberate la promovarea examenelor.
            </Feature>
            <Feature icon="fa-stethoscope" bg="#fdf1de" color="#8a5a04" title="Rezidenți">
              Curiculă structurată pe ani de rezidențiat, conform programei oficiale. Module practice cu video demonstrative și cazuri clinice.
            </Feature>
            <Feature icon="fa-hand-holding-medical" bg="#ede4fa" color="#4a2c91" title="Asistenți medicali">
              Protocoale de îngrijire, igienă și sterilizare, intervenții în urgență. Conținut adaptat rolului zilnic în secție.
            </Feature>
          </div>
        </div>
      </section>

      <section id="cum-functioneaza" style={{ background: "#fff", borderTop: "1px solid var(--c-line)", borderBottom: "1px solid var(--c-line)" }}>
        <div className="container">
          <div className="section-head">
            <span className="eyebrow"><span className="dot"></span>Cum funcționează</span>
            <h2>Trei pași simpli</h2>
          </div>
          <div className="grid-3">
            <Feature icon="fa-right-to-bracket" title="1. Autentificare">
              Folosești adresa de email instituțională. Contul este creat de coordonatorul programului din spital.
            </Feature>
            <Feature icon="fa-book-open" title="2. Parcurgi cursurile">
              Lecții text și video, materiale descărcabile (PDF), recapitulări. Progresul se salvează automat — poți relua oricând.
            </Feature>
            <Feature icon="fa-certificate" title="3. Susții examenul">
              La finalul fiecărui curs, examen grilă cu corectare automată. Certificatul este emis instant în format PDF.
            </Feature>
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="cta-band">
            <h2>Acces personal al spitalului</h2>
            <p>Dacă lucrezi în Spitalul Marie Curie și nu ai încă acces la platformă, contactează coordonatorul departamentului tău.</p>
            <Link to="/login" className="btn btn-primary btn-lg"><i className="fa-solid fa-right-to-bracket"></i> Autentificare</Link>
          </div>
        </div>
      </section>

      <footer className="footer" id="contact">
        <div className="container">
          <div className="footer-grid">
            <div>
              <div className="brand" style={{ marginBottom: 14 }}>
                <img src="/logo.svg" alt="" width={44} height={44} />
                <div className="brand-text"><span>Spitalul Marie Curie</span><small>Platformă internă de formare</small></div>
              </div>
              <p style={{ color: "#8a9aa0", maxWidth: 340, fontSize: ".92rem" }}>Platformă internă pentru educație medicală continuă, dedicată exclusiv personalului Spitalului Marie Curie.</p>
            </div>
            <div>
              <h4>Acces rapid</h4>
              <ul>
                <li><Link to="/login">Autentificare</Link></li>
                <li><a href="#program">Despre program</a></li>
                <li><a href="#cum-functioneaza">Cum funcționează</a></li>
              </ul>
            </div>
            <div>
              <h4>Suport intern</h4>
              <ul>
                <li><a href="mailto:platforma@mariecurie.ro?subject=Întrebare%20platformă">Trimite o întrebare</a></li>
                <li><a href="mailto:platforma@mariecurie.ro?subject=Resetare%20cont">Probleme cu contul</a></li>
                <li><a href="mailto:coordonator@mariecurie.ro?subject=Înregistrare%20utilizator">Solicită cont nou</a></li>
              </ul>
            </div>
            <div>
              <h4>Spital</h4>
              <ul>
                <li><a href="mailto:contact@mariecurie.ro"><i className="fa-regular fa-envelope"></i> contact@mariecurie.ro</a></li>
                <li><a href="tel:+40211234567"><i className="fa-solid fa-phone"></i> Centrala spitalului</a></li>
                <li><i className="fa-solid fa-location-dot"></i> București, România</li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <span>© 2026 Spitalul Marie Curie · Platformă internă de formare</span>
            <span>Acces rezervat personalului</span>
          </div>
        </div>
      </footer>
    </>
  );
}

interface FeatureProps {
  icon: string;
  title: string;
  children: React.ReactNode;
  bg?: string;
  color?: string;
}

function Feature({ icon, title, children, bg, color }: FeatureProps) {
  return (
    <div className="feature">
      <div className="feature-icon" style={bg ? { background: bg, color } : undefined}>
        <i className={`fa-solid ${icon}`}></i>
      </div>
      <h3>{title}</h3>
      <p>{children}</p>
    </div>
  );
}
